import React, { useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { array } from 'yup';

type LegendProps = { 
  map: L.Map;
};

const Legend: React.FC<LegendProps> = ({ map }) => {
  const grades = [1, 14, 28, 42, 58, 72, 85, 100];       
  const getColor = (d : any) => {
    // Definir la función getColor aquí o importarla desde otro archivo
    return d > 85 ? '#800026' :
            d > 72 ? '#BD0026' :
            d > 58 ? '#E31A1C' :
            d > 42 ? '#FC4E2A' :
            d > 28 ? '#FD8D3C' :
            d > 14 ? '#FEB24C' :
            d > 1 ? '#FED976' : '#FFEDA0';
  }

  return (
    <div className="legend-panel info legend" style={{width:"auto", height:"auto", position:'absolute', bottom:'10px', right:'10px', padding:'10px', zIndex:'20001'}}>
      {grades.map((child: any, index) => (
          <div key={child}><i  className='mb-0' style={{background:getColor(grades[index] +1)}}></i>{grades[index]}{grades[index + 1]?(<>&ndash;{grades[index + 1]}</>):(<>+</>)}<br/></div>
        ))}     
    </div>
  );  // No es necesario renderizar nada en el DOM para este componente
};

export default Legend;